import { render, staticRenderFns } from "./ContactUploadModal.vue?vue&type=template&id=1ba0004e"
import script from "./ContactUploadModal.vue?vue&type=script&lang=ts"
export * from "./ContactUploadModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports